import { Button } from "atoms/button/Button";
import { TextField } from "atoms/text-field/TextField";

import { QuizStepProps } from "../useQuestionnaire";

export const StartingWeight = (props: QuizStepProps) => {
  const hasError = !!props.errors?.StartingWeight;

  return (
    <div className="flex h-full flex-col">
      <div className="pb-8 font-serif text-h3">
        What was your starting weight in pounds (lbs)?
      </div>
      <div>
        <TextField
          label="Weight (lbs)"
          type="number"
          invalid={hasError}
          value={props.data.StartingWeight as string}
          onChange={(value) => props.handleStepData("StartingWeight", value)}
        />
      </div>
      {hasError && (
        <p className="pt-2 text-sm text-red">{props.errors?.StartingWeight}</p>
      )}
      <div className="mt-auto">
        <Button fullWidth onClick={props.next}>
          Next Question
        </Button>
      </div>
    </div>
  );
};
